// @ts-check
import { nanoid } from "nanoid";
import { merge, cloneDeep } from "lodash";
import * as ACTIONS from "../actionTypes";
import { SUCCESS } from "../saveStatus";

export default (state, action) => {
  switch (action.type) {
    case ACTIONS.MAIN_QUERY_COMPLETE: {
      const { data } = action;
      return {
        ...state,
        data: cloneDeep(data), // convert from immutable to mutable
        refreshPart1: false,
        refreshPart2: false,
        loading: false,
        firstLoad: false,
      };
    }
    case ACTIONS.UPDATE_DATE_RANGE_TOTAL_FTE: {
      // take a copy of the intersectingFteData
      const { dataForRanges: intersectingFteData } = action;
      return {
        ...state,
        intersectingFteData: cloneDeep(intersectingFteData), // convert from immutable to mutable
        firstLoad: false,
      };
    }
    case ACTIONS.BASELINE_DIFF_QUERY_COMPLETE: {
      // take a copy of the diff query
      return {
        ...state,
        groupDiffData: action?.groups,
      };
    }
    case ACTIONS.MAIN_QUERY_ERROR: {
      const { error } = action;
      return {
        ...state,
        error,
        loading: false,
      };
    }
    case ACTIONS.MAIN_QUERY_REFRESH: {
      const { backgroundRefresh, refreshPart1, refreshPart2 } = action;
      const { loading } = state;

      if (!loading) {
        const refreshId = nanoid();
        return {
          ...state,
          loading: true,
          backgroundRefresh,
          refreshPart1,
          refreshPart2,
          variables: {
            ...state.variables,
            refreshId,
          },
        };
      }

      return state; // do nothing
    }

    case ACTIONS.UPDATE_REFERENCE_DATE: {
      const { referenceDate } = action;
      const { variables } = state;
      const refreshId = nanoid();

      // Persist referenceDate to localStorage
      localStorage.setItem("forecastReferenceDate", referenceDate);

      return {
        ...state,
        loading: true,
        refreshPart1: true,
        refreshPart2: true,
        variables: {
          ...variables,
          referenceDate,
          refreshId,
        },
      };
    }
    case ACTIONS.SUBMITTING_ALL: {
      return {
        ...state,
        loading: true,
      };
    }
    case ACTIONS.SUBMIT_FORECAST_COMPLETE:
    case ACTIONS.SUBMIT_ALL_COMPLETE: {
      const refreshId = nanoid();
      return {
        ...state,
        data: null,
        intersectingFteData: null,
        loading: true,
        refreshPart1: true,
        refreshPart2: true,
        variables: {
          ...state.variables,
          refreshId,
        },
      };
    }
    case ACTIONS.SUBMIT_ALL_ERROR: {
      const { error } = action;
      return {
        ...state,
        error,
        loading: false,
      };
    }
    case ACTIONS.TOGGLE_PAGE_LOADING: {
      const { loading } = action;
      return {
        ...state,
        loading,
      };
    }
    case ACTIONS.SKILLS_SAVE_STATUS_UPDATE:
    case ACTIONS.CELL_VALUE_SAVE_STATUS_UPDATE: {
      const { status, macroAllocation } = action;

      if (status === SUCCESS && macroAllocation) {
        const existing = state.data.macroAllocations.find(
          (ma) => ma.id === macroAllocation.id
        );
        if (existing) {
          merge(existing, macroAllocation);
        } else {
          // eslint-disable-next-line no-param-reassign
          state.data.macroAllocations = [
            ...(state.data.macroAllocations || []),
            macroAllocation,
          ];
        }
      }

      return {
        ...state,
      };
    }
    case ACTIONS.CONSTRAINT_SAVE_STATUS_UPDATE: {
      const { status, constraint } = action;
      if (status === SUCCESS && constraint && state.data) {
        if (!state.data.constraints) {
          // eslint-disable-next-line no-param-reassign
          state.data.constraints = [];
        }
        const existing = state.data.constraints.find(
          (ma) => ma.id === constraint.id
        );
        if (existing) {
          merge(existing, constraint);
        } else {
          state.data.constraints.push(constraint);
        }
      }
      return {
        ...state,
      };
    }
    case ACTIONS.USER_ADD_ROLE: {
      const { role } = action;
      const existing = state.data.macroAllocationGroups?.find(
        (g) => g.id === role.id
      );
      if (!existing) {
        // eslint-disable-next-line no-param-reassign
        state.data.macroAllocationGroups = [
          ...(state.data.macroAllocationGroups || []),
          role,
        ];
      }

      return {
        ...state,
      };
    }
    default:
      return state;
  }
};
